import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";

var _hoisted_1 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("i", {
  "class": "fa fa-angle-left",
  "aria-hidden": "true"
})], -1);

var _hoisted_2 = [_hoisted_1];
var _hoisted_3 = ["onClick"];

var _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("i", {
  "class": "fa fa-angle-right",
  "aria-hidden": "true"
})], -1);

var _hoisted_5 = [_hoisted_4];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("ul", {
    "class": _normalizeClass(["pagination", [$props.size && "pagination-".concat($props.size), $props.align && "justify-content-".concat($props.align)]])
  }, [_createElementVNode("li", {
    "class": _normalizeClass(["page-item prev-page", {
      disabled: $props.value === 1
    }])
  }, [_createElementVNode("a", {
    "class": "page-link",
    "aria-label": "Previous",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.prevPage && $options.prevPage.apply($options, arguments);
    })
  }, _hoisted_2)], 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.range($options.minPage, $options.maxPage), function (item) {
    return _openBlock(), _createElementBlock("li", {
      "class": _normalizeClass(["page-item", {
        active: $props.value === item
      }]),
      key: item
    }, [_createElementVNode("a", {
      "class": "page-link",
      onClick: function onClick($event) {
        return $options.changePage(item);
      }
    }, _toDisplayString(item), 9, _hoisted_3)], 2);
  }), 128)), _createElementVNode("li", {
    "class": _normalizeClass(["page-item next-page", {
      disabled: $props.value === $options.totalPages
    }])
  }, [_createElementVNode("a", {
    "class": "page-link",
    "aria-label": "Next",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.nextPage && $options.nextPage.apply($options, arguments);
    })
  }, _hoisted_5)], 2)], 2);
}